import { useTranslation } from 'react-i18next';
import { useTheme, createUseStyles } from 'react-jss';
import { ToolTipStyles } from '../styles';
import { Theme } from '../../../../jss';
import { buildClassName } from '../../../../helpers';
import { ToolTip, ToolTipProps, ToolTipState } from '../../..';

export function useToolTipEffect(props: ToolTipProps): [ToolTipState] {
  const { styleClasses } = props;
  const { t } = useTranslation();

  const useStyles = createUseStyles(ToolTipStyles);
  const theme = useTheme();
  const classes = useStyles({ ...props, theme: theme as Theme });
  const className = buildClassName({ styleClasses, classes });

  const tips: ToolTip[] = props.tips.map((tip: ToolTip) => {
    const { type, message } = tip;
    const translatedTip: ToolTip = { type, message: t(message) };

    return translatedTip;
  });

  const state: ToolTipState = { className, tips };

  return [state];
}
